import { createPolymorphicComponent, Timeline, TimelineProps } from "@mantine/core";
import styled from "styled-components";

type MessagesTimelineProps = {
    children: React.ReactNode;
    bulletSize?: number;
}

const _MessagesTimelineWrapper = styled(Timeline)`     
    & .mantine-Timeline-item:not(:first-child) {
        margin-top: var(--mantine-spacing-sm)
    }
    & .mantine-Timeline-itemTitle {
        line-height: 30px;
    }
    & .mantine-Timeline-itemBody {
        padding-inline-start: var(--mantine-spacing-sm);
    }
`
const MessagesTimelineWrapper = createPolymorphicComponent<'div', TimelineProps>(_MessagesTimelineWrapper);

export const MessagesTimeline: React.FC<MessagesTimelineProps> = ({ children, bulletSize = 30 }) => {

    return (
        <MessagesTimelineWrapper
            bulletSize={bulletSize}
        >
            {children}
        </MessagesTimelineWrapper>
    )

}